interface SVGProps {
  color: string;
  style: React.CSSProperties;
}

const SVG = ({ color, style }: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="67"
    height="52"
    viewBox="0 0 67 52"
    fill="none"
  >
    <path
      d="M54.8372 24.9397V3.90179C54.8372 2.29743 53.5397 1 51.9354 1H3.73504C2.13069 1 0.833252 2.29743 0.833252 3.90179V41.5413C0.833252 43.5363 2.45156 45.1546 4.44653 45.1546H38.2914"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.08772 5.93876C8.08772 5.65974 7.8645 5.43652 7.58548 5.43652C7.30647 5.43652 7.08325 5.65974 7.08325 5.93876C7.08325 6.21777 7.30647 6.44099 7.58548 6.44099C7.8645 6.44099 8.08772 6.21777 8.08772 5.93876Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.8773 5.93876C13.8773 5.65974 13.6541 5.43652 13.375 5.43652C13.096 5.43652 12.8728 5.65974 12.8728 5.93876C12.8728 6.21777 13.096 6.44099 13.375 6.44099C13.6541 6.44099 13.8773 6.21777 13.8773 5.93876Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.6671 5.93876C19.6671 5.65974 19.4438 5.43652 19.1648 5.43652C18.8858 5.43652 18.6626 5.65974 18.6626 5.93876C18.6626 6.21777 18.8858 6.44099 19.1648 6.44099C19.4438 6.44099 19.6671 6.21777 19.6671 5.93876Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M0.833252 10.9326H54.8372"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M45.6853 46.7313L41.2908 51.0003V32.5014C41.2908 29.9763 43.3276 27.9395 45.8527 27.9395H61.4219C63.947 27.9395 65.9839 29.9763 65.9839 32.5014V42.1694C65.9839 44.6945 63.947 46.7313 61.4219 46.7313H45.6993H45.6853Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M48.8242 34.7471H58.7433"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M48.8242 39.4766H58.7433"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30.8978 34.3681C34.844 32.7224 36.7179 28.1674 35.0833 24.1943C33.4488 20.2211 28.9247 18.3344 24.9785 19.9801C21.0323 21.6258 19.1583 26.1808 20.7929 30.154C22.4275 34.1271 26.9516 36.0139 30.8978 34.3681Z"
      stroke={color}
      strokeWidth="1.75"
      strokeMiterlimit="10"
      strokeLinecap="round"
    />
    <path
      d="M25.5188 27.1504L27.4908 28.929L30.3461 25.4131"
      stroke={color}
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SVG;
